import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import EmptyState from '../../../EmptyState';
import { URLS } from '@wix/da-url/dist/src/constants';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import s from './SubscriptionsCoreOnlyBlock.scss';

export interface Props {
  className?: string;
  hasCore: boolean;
  createTier: () => void;
}

const SubscriptionsCoreOnlyBlock: React.FC<Props> = ({
  className,
  hasCore,
  createTier,
}) => {
  const { t } = useTranslation();

  let variant;
  let cta;
  let secondaryCta;
  // eslint-disable-next-line default-case
  switch (true) {
    case hasCore:
      variant = 'hasCore';
      cta = (
        <SolidButton
          variant="approval-green"
          size="medium"
          priority="primary"
          onClick={createTier}
          className={s['button']}
          biData={{
            evid: BiEventType.TIER_ADD_NEW,
            is_empty_state_view: 1,
            widgetname: undefined,
          }}
        >
          {t('page.subscriptions.coreOnlyBlock.CTAbutton.createTier')}
        </SolidButton>
      );
      break;
    case !hasCore:
      variant = 'noCore';
      cta = (
        <BrandedButton
          size="medium"
          variant="core-orange"
          href={URLS.CORE_MEMBERSHIP}
          className={s['button']}
          biData={{
            evid: BiEventType.BUY_CORE_BUTTON,
            referral_info: ReferralType.SUBSCRIPTIONS,
          }}
        >
          {t('page.subscriptions.coreOnlyBlock.CTAbutton.buyCore')}
        </BrandedButton>
      );
      secondaryCta = (
        <GhostButton
          variant="core-orange"
          size="medium"
          onClick={createTier}
          className={s['button']}
          biData={{
            evid: BiEventType.TIER_ADD_NEW,
            is_empty_state_view: 1,
            widgetname: undefined,
          }}
        >
          {t('page.subscriptions.coreOnlyBlock.CTAbutton.startCreatingATier')}
        </GhostButton>
      );
      break;
  }

  return (
    <EmptyState
      className={c(s['root'], className)}
      title={t(
        `page.subscriptions.coreOnlyBlock.title.var.${variant}.updatedTiers`
      )}
      subtitle={
        <div className={s['subtitle-wrapper']}>
          <div className={s['subtitle']}>
            {t(
              `page.subscriptions.coreOnlyBlock.subtitle.var.${variant}.updatedTiers`
            )}
          </div>
          {hasCore && (
            <TextButton
              size="medium"
              variant="main"
              href={t('widgets.subscriptionsSection.tips.top.url')}
            >
              {t('page.subscriptions.coreOnlyBlock.CTAbutton.learnMore')}
            </TextButton>
          )}
        </div>
      }
      illustration={<div className={s['illustration']} />}
      withIllustrationBelow
      customButton={cta}
      customSecondaryButton={secondaryCta}
    />
  );
};
SubscriptionsCoreOnlyBlock.displayName = 'SubscriptionsCoreOnlyBlock';

export default SubscriptionsCoreOnlyBlock;
